module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium.7c4f2d80.ttf";